import { useState, useEffect } from 'react';
import { UserAuth } from '../context/AuthContext';
import { Navigate, useNavigate } from 'react-router-dom';
import { auth } from '../firebase-config';

const useLoginForm = (callback, validate) => {
  const [values, setValues] = useState({
    email: '',
    password: '',
  });

  const { user } = UserAuth();
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { signIn } = UserAuth();
  const navigate = useNavigate();

  const handleChange = e => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signIn(values.email, values.password);
      setIsSubmitting(true);
      auth.onAuthStateChanged(user => {
        if (user) {
          navigate('/account');
        }
      })
      
    } catch (e) {
      console.log(e.message);
      console.log(values)
      setErrors(validate(values));
      if (e.message == 'Firebase: Error (auth/wrong-password).') {
        setErrors(validate('incorrect pass'));
      }
    }
  };

  return { handleChange, handleSubmit, values, errors };
};

export default useLoginForm;